const $ = window.$;
$(document).ready(function(){

});